
export class FilenameHelper {
  public static extractFilename(content: string) {
    const split = content.split(`''`);
    const filenameIndex = split.length - 1
    return split[filenameIndex];
  }
}
